module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0120.jpg?v=5eac83d8";